import type { IconProps } from '../../../../src/features/common/types/common';

const PlantedTreesBlackIcon = ({ color, width, height }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 43 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.7066 18.0551C28.2376 18.8417 31.6332 20.072 36.2058 15.6853C41.9555 10.1188 42.8616 3.37242 42.9971 0.79085C43.0387 0.357227 42.6325 -0.046144 42.1846 0.00427738C39.4244 0.135373 31.6437 0.528659 25.7586 6.26661C21.2381 10.6432 21.9985 13.3659 22.9047 14.6365C26.0711 11.218 30.4667 8.11203 35.8934 6.13551C34.081 7.18428 29.873 10.0381 26.6648 13.1945C24.0817 15.7357 21.8214 18.4988 20.3736 21.4333C19.5091 19.3762 17.9779 16.966 15.5718 14.4651C12.5408 11.2684 8.46817 8.33388 6.69746 7.2347C11.9888 9.34231 16.1968 12.539 19.2278 15.9979C20.1757 14.7676 20.9881 12.1457 16.6968 7.66832C11.1763 1.79928 3.53101 1.23456 0.864524 0.972367C0.406222 0.93203 0 1.27489 0 1.7186C0.0416638 4.25984 0.677037 10.9155 6.19749 16.5727C10.041 20.556 13.1658 20.1224 15.5614 19.4669C16.4676 20.5157 18.4987 23.2384 18.4571 26.8688C13.9365 27.3528 10.0826 29.1478 7.95779 31.689C7.5099 32.2134 7.91612 33 8.59316 33H32.8936C33.6227 33 33.9768 32.2134 33.5289 31.689C31.352 29.1075 27.3315 27.2217 22.6234 26.8284C22.5401 22.1292 24.6233 19.6383 25.7066 18.0551Z"
        fill={`${color}`}
      />
    </svg>
  );
};

export default PlantedTreesBlackIcon;
